import '../../src/App.css';
import '../../src/Css/bootstrap.min.css';
import Login from '../../src/Pages/login';
import HomePage from './pages/index';
import Loader from 'react-loader-spinner';
import Menu from '../Components/Header/Menu';
import { useState, useEffect, Fragment } from 'react';
import PopupMenu from '../../src/Components/PopupMenu';
import ModalDialog from '../../src/Components/Modals/ModalDialog';
import MenuWide from '../Components/Header/MenuWide';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PrintViewer from '../Pages/PrintViewer';
import AutoDocumentMapping from './pages/AutoDocumentMapping';
import AccountsChart from './pages/AccountsChart';
import AddEditDocument from './pages/AddEditDocument';
import SearchDocuments from './pages/SearchDocuments';
import AccountingBalance from './pages/AccountingBalance';
import AccountingBook from './pages/AccountingBook';
import ManageCostCenters from './pages/ManageCostCenters';
import CreditorDebtorList from './pages/CreditorDebtorList';
import { getActiveSubsystems, isMobileApp, isWebApp } from '../store/api/CommonFunctions';
import { useDispatch } from 'react-redux';
import SearchCommands from '../Pages/SearchCommands';
import { getAppConfig } from '../store/api/SystemSettingsAPI';
import SearchCheques from './pages/SearchCheques';
import UserDashboard from '../Pages/UserDashboard';
import ViewAccountsReport from './pages/ViewAccountsReport';
import ModalSMSTemplates from '../Components/Modals/ModalSMSTemplates';
import SearchSentSMS from '../Pages/SearchSentSMS';
import SearchReceivedSMS from '../Pages/SearchReceivedSMS';
import AccountBalanceReport from './pages/AccountBalanceReport';
import BenefitItems from './pages/BenefitItems';

const requireAuth = (setUser) => {
  const token = localStorage.getItem('token');
  if (token !== null && token) {
    setUser(token);
  } else {
    setUser(null);
  }
}


function App(props) {
  const dispatch = useDispatch();
  const [pending, setPending] = useState(true);
  const [currentUser, setUser] = useState(null);
  const [menuWidth, setMenuWidth] = useState(false);
  const{setModalAboutUs, setQAList} = props;
  const [forgetPassword, setForgetPassword] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
  useEffect(() => {
    requireAuth(setUser);
    setPending(false);
    dispatch(getActiveSubsystems());
    dispatch(getAppConfig());
    document.getElementById("CompanyName")?.setAttribute("systemname", "سیستم حسابداری");
  }, []);
  return (
    <div className="App">
      <Router>
        {currentUser &&
          <Fragment>
            <ModalDialog />
            <PopupMenu />
            <div style={{ height: "20px" }}>
              {isMobileApp() && <Menu menuName="Accounting"/>}
              {isWebApp() &&
                <Fragment>
                  <span style={{ fontSize: "30px", cursor: "pointer", position: "absolute", right: "15px", top: "6px" }} onClick={() => { setMenuWidth("250px") }}>&#9776;</span>
                  <MenuWide menuWidth={menuWidth} setMenuWidth={setMenuWidth} currentUser={currentUser} setModalAboutUs={setModalAboutUs}
                   menuName="Accounting" setQAList={setQAList} />
                </Fragment>}
            </div>
            <Switch>
              <Route path="/PrintViewer/:reportName/:designMode"><PrintViewer /></Route>
              <Route path = "/Accounting/AutoDocumentMapping"><AutoDocumentMapping/></Route>
              <Route path = "/Accounting/AccountsChart"><AccountsChart/></Route>
              <Route path="/Accounting/AddEditDocument/:documentID"><AddEditDocument/></Route>
              <Route path="/Accounting/SearchDocuments"><SearchDocuments/></Route>
              <Route path="/Accounting/AccountingBalance/:level/:parentID"><AccountingBalance/></Route>
              <Route path="/Accounting/AccountingBook/:level/:accountID/:accountCat"><AccountingBook/></Route>
              <Route path="/Accounting/ManageCostCenters"><ManageCostCenters/></Route>
              <Route path="/Accounting/CreditorDebtorList"><CreditorDebtorList/></Route>
              <Route path="/SearchCommands"><SearchCommands/></Route>
              <Route path="/SMSTemplates"> <ModalSMSTemplates /></Route>
              <Route path="/SearchSentSMS"><SearchSentSMS /></Route>
              <Route path="/SearchReceivedSMS"><SearchReceivedSMS /></Route>
              <Route path="/Accounting/SearchCheques"><SearchCheques/></Route>
              <Route path="/UserDashboard"><UserDashboard /></Route>
              <Route path="/Accounting/ViewAccountsReport/:reportTypeParam/:cat?/:id?"><ViewAccountsReport/></Route>
              <Route path="/Accounting/AccountBalanceReport"><AccountBalanceReport/></Route>
              <Route path="/Accounting/BenefitItems"><BenefitItems/></Route>
              <Route path={userInfo?.HomePage ==="Accounting"?"/":"/Accounting"}><HomePage /></Route>

            </Switch>
          </Fragment>
        }
        {pending &&
          <Loader type="BallTriangle"
            color="#bb1370"
            height={50}
            width={50} />}

        {!pending && !currentUser && !forgetPassword &&
          <Login setUser={setUser} setForgetPassword={setForgetPassword} />}
      </Router>
    </div>
  );
}

export default App;
